require('./dealer-filter.tag');
require('./dealer-filter-select.tag');
require('./../raw-html.tag');
riot.tag2('dealer-filters', '<div class="filters-container {\'is-expanded\': isOpen}"> <zip-input></zip-input> <div if="{!isStartReservation}" class="filter-selector {\'is-disabled\': isDisabled} "> <div class="filters-header"> <div class="filters-title-container"> <h4 class="filters-title"> <button class="filters-title-cta acr-caption-9" onclick="{toggleFilter}" type="button" data-tracking="{trackingFilteringModelData}"> <span class filters-title-cta__heading>{getFiltersTitleHeading()}</span><span class="filters-title-cta__value acr-paragraph-5">{getFiltersTitleValue()}</span> <acr-svg svg-id="cta-arrow-down" svg-class="acr-icon filter-dropdown-icon" svg-viewbox="0 0 26 26"></acr-svg> </button> </h4> </div> </div> <div class="filters-dropdown"> <div class="filters-dropdown-container {\'is-open\': isOpen}"> <div class="filter-section" each="{filterSection in filters}" if="{!filterSection.isHidden}"> <ul class="filter-list"> <li class="filter-item" data-is="dealer-filter" each="{filter in filterSection.items}" if="{filter.show}" filter-section="{filterSection.name}"></li> </ul> </div> <div class="filter-tooltip {\'is-active\': isTooltipActive}"> <button class="filter-close-btn" onclick="{closeTooltip}"> <acr-svg svg-id="close" svg-class="filter-close-icon" svg-viewbox="0 0 26 26"></acr-svg> </button> <h5 class="filter-tooltip-title acr-caption-6"> <raw-html content="{tooltipTitle}"></raw-html> </h5> <p class="filter-tooltip-copy acr-paragraph-5"> <raw-html content="{tooltipText}"></raw-html> </p> </div> </div> </div> </div> </div> </dealer-filters>', '', '', function(opts) {
    var filterService = require('../../core/Filters.js');
    var trackingJSON = require('../../data/tracking-data');
    var self = this;
    self.appliedFilters;
    self.trackingFilteringModelData = JSON.stringify(trackingJSON.filteringModel);
    self.dealersAttributes = [];
    self.tooltipText = 'test acura copy';
    self.tooltipTitle = 'test acura title';
    self.isTooltipActive = false;
    self.isOpen = false;
    self.isDisabled = false;
    self.showDistance = (self.opts.showDistance !== undefined) ? self.opts.showDistance : true;
    self.isStartReservation = window.dealerLocator && window.dealerLocator.isStartReservation;
    this.mixin('bus');

    function mapFiltersCodes(previous, filter) {
      var show = false;

      show = self.dealersAttributes.indexOf(filter.code) !== -1;

      return show;
    }

    function mapFilters(filter) {
      var newFilter = filter;

      self.appliedFilters = filterService.get();

      newFilter.isSelected = filter.codes.reduce(function checkIfSelcted(value, code){
        var currentValue = false;
        if (self.appliedFilters.applied.length > 0) {
          self.appliedFilters.applied.forEach(function iterateAppliedFilters(item){
            if (item.length > 0 && item[0].code === code.code){
              currentValue = true;
            }
          });
        }
        return value || currentValue;
      }, false);

      if (newFilter.alwaysShown){
        newFilter.show = true;

        newFilter.codes.map(function filterMap(code) {
          return code = code.alwaysShown = true;
        });
      }
      else {
        newFilter.show = (newFilter.codes.length > 1)
          ? filter.codes.reduce(mapFiltersCodes, true)
          : mapFiltersCodes(true, filter.codes[0]);
      }

      return newFilter;
    }

    function reduceFilters(previous, filter) {
      var show = true;

      show = (filter.codes.length > 1)
        ? filter.codes.reduce(mapFiltersCodes, show)
        : mapFiltersCodes(show, filter.codes[0]);

      return show || previous;
    }

    function mapFiltersSection(section) {
      var newSection = section;
      newSection.items = newSection.items.map(mapFilters);
      newSection.isHidden = !newSection.items.reduce(reduceFilters, newSection.isHidden);

      return newSection;
    }

    function validateFilters() {
      self.filters = self.filters.map(mapFiltersSection);
      self.bus.trigger(self.bus.EVENTS.FILTERS.UPDATE);
    }

    function toggleFilter() {
      self.dealersAttributes = filterService.getDealersAttributes();
      if(self.dealersAttributes.length == 0 ) {
        self.isOpen = false;
        resetFilters();
      }
      else {
        self.isOpen = !self.isOpen;
        validateFilters();
      }

      self.update();
    }

    function applyFilters() {
      var opts = {};

      if (self.opts.showDistance) {
        opts.distance = self.tags['filter-select'].selectedDistance;
      }

      self.bus.trigger(this.bus.EVENTS.FILTERS.APPLY, opts);
    }

    function resetFilters() {
      filterService.reset();
      filterService.cleanSelectedFilters();
      self.bus.trigger(self.bus.EVENTS.FILTERS.RESET);
    }

    function openTooltip() {
      self.isTooltipActive = true;

      self.tooltipText = event.currentTarget
      .getElementsByClassName('filter-item-desc')[0]
      .innerText;

      self.tooltipTitle = event.currentTarget
      .getElementsByClassName('filter-item-title')[0]
      .innerText;
    }

    function closeTooltip() {
      self.isTooltipActive = false;
    }

    function closeFilter() {
      self.isOpen = false;

      closeTooltip();
      self.update();
    }

    function getFilterNameByCode(filterCode) {
      var filterName = '';
      var selectedFilter = [];

      self.filters.map(function filterSectionMap(filterSection) {
        var filters = filterSection.items.filter(function filterMap(filter) {
          var isSelected = filter.codes.reduce(function codesReduce(value, code) {
            value = value || code.code.toLowerCase() === filterCode.toLowerCase();
            return value;
          }, false);
          return isSelected;
        });
        selectedFilter = selectedFilter.concat(filters)
      });

      if (selectedFilter.length > 0) {
        filterName = selectedFilter[0].title;
      }

      return filterName;
    }

    function checkDropdownStatus() {
      self.dealersAttributes = filterService.getDealersAttributes();
      if(self.dealersAttributes.length == 0 ) {
        self.isDisabled = true;
      }
      else {
        self.isDisabled = false;
      }
    }

    self.getFiltersTitleValue = function getFiltersTitleValue() {
      var filterButtonText = '';
      self.appliedFilters = filterService.get();
      var appliedFiltersCount = self.appliedFilters.applied.length;
      self.dealersAttributes = filterService.getDealersAttributes();
      if (appliedFiltersCount > 0 && self.dealersAttributes.length > 0){
        filterButtonText += appliedFiltersCount > 1 ? appliedFiltersCount +  ' Selected' :
          getFilterNameByCode(self.appliedFilters.applied[0][0].code)
      }

      return filterButtonText;
    }

    self.getFiltersTitleHeading = function getFiltersTitleHeading() {
      var filterButtonText = self.labels.filterTitle;
      self.dealersAttributes = filterService.getDealersAttributes();
      if(self.dealersAttributes.length > 0 ) {
        self.appliedFilters = filterService.get();
        var appliedFiltersCount = self.appliedFilters.applied.length;
        filterButtonText += appliedFiltersCount > 0 ? ' BY: ' : '';
      }

      return filterButtonText;
    }

    this.on('update', function onUpdate() {
      checkDropdownStatus();
    });

    this.bus.on(this.bus.EVENTS.FILTERS.OPEN_TOOLTIP, openTooltip);
    this.bus.on(this.bus.EVENTS.DEALERS.SEARCH, closeFilter);

    self.closeFilter = closeFilter;
    self.applyFilters = applyFilters;
    self.resetFilters = resetFilters;
    self.toggleFilter = toggleFilter;
    self.closeTooltip = closeTooltip;
});
